import { render, staticRenderFns } from "./AITemplate.vue?vue&type=template&id=7675614a&scoped=true"
import script from "./AITemplate.vue?vue&type=script&lang=js"
export * from "./AITemplate.vue?vue&type=script&lang=js"
import style0 from "./AITemplate.vue?vue&type=style&index=0&id=7675614a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7675614a",
  null
  
)

export default component.exports